import Vue from 'vue';
import Select2MultipleControl from 'v-select2-multiple-component';
Vue.component('Select2MultipleControl', Select2MultipleControl);

!(function($) {
  "use strict";

  new Vue({
    el: '#details_form_app',
    data: {
      companyPropertyOptions: [],
      organizationRoleOptions: [],
      detailBrandOptions: [],
      detailBrandSettings: {
        placeholder: "請選擇品牌"
      },
      brand_ids: [],
      organization_role_array: [],
      profile: {
        company_property: "",
        other_property: "",
        organization_role: "",
        other_role: "",
        phone_number: "",
        job_title: "",
        is_news_letter: true,
      }
    },
    mounted: function() {
      let that = this;

      $.ajax({
        url: '/users/profile/get_form_data',
        type: 'GET',
        dataType: 'json',
      }).done(function(data) {
        that.companyPropertyOptions = data.company_property_options;
        that.organizationRoleOptions = data.organization_role_options;
        that.detailBrandOptions = data.brand_options;
        that.brand_ids = data.brand_ids;

        if (data.profile) {
          that.profile.company_property = data.profile.company_property;
          that.profile.other_property = data.profile.other_property;
          that.profile.organization_role = data.profile.organization_role;
          that.organization_role_array = data.profile.organization_role.split(',');
          that.profile.other_role = data.profile.other_role;
          that.profile.phone_number = data.profile.phone_number;
          that.profile.job_title = data.profile.job_title;
          that.profile.is_news_letter = data.profile.is_news_letter;
        }
      });

    },
    computed: {
      lockSubmit: function() {
        if (this.profile.company_property == "" || this.organization_role_array.length == 0 || 
          this.brand_ids.length == 0 || this.profile.job_title == "" ||
          (this.profile.company_property == "other_property" && this.profile.other_property == "") ||
          (this.organization_role_array.includes("other_role") && this.profile.other_role == "")) {
          return true;
        }
        return false;
      },
    },
    methods: {
      submit: function() {
        var token = document.querySelector('meta[name="csrf-token"]').content;

        if (this.profile.company_property == "" || this.organization_role_array.length == 0 || 
          this.brand_ids.length == 0 || this.profile.job_title == "" ||
          (this.profile.company_property == "other_property" && this.profile.other_property == "") ||
          (this.organization_role_array.includes("other_role") && this.profile.other_role == "")) {
          $(".err-message").removeClass('hidden');
          return;
        }

        this.profile.organization_role = this.organization_role_array.join(',');

        $.ajax({
          url: '/users/profile',
          type: 'POST',
          dataType: 'json',
          data: {authenticity_token: token,profile: this.profile, brand_ids: this.brand_ids},
        }).done(function(data) {
          window.location = "/"
        });
      },
      submitUpdate: function() {
        var token = document.querySelector('meta[name="csrf-token"]').content;

        if (this.profile.company_property == "" || this.organization_role_array.length == 0 || 
          this.brand_ids.length == 0 || this.profile.job_title == "" ||
          (this.profile.company_property == "other_property" && this.profile.other_property == "") ||
          (this.organization_role_array.includes("other_role") && this.profile.other_role == "")) {
          $(".err-message").removeClass('hidden');
          return;
        }

        this.profile.organization_role = this.organization_role_array.join(',');

        $.ajax({
          url: '/users/profile',
          type: 'PUT',
          dataType: 'json',
          data: {authenticity_token: token,profile: this.profile, brand_ids: this.brand_ids},
        }).done(function(data) {
          window.location = "/users/profile/edit"
        });
      },
    },
  });

})(jQuery);
